import React from "react";
import { Link } from "react-router-dom";
const ItemsMenu = ({ token, username, isActive, onToggle }) => {
  if (username.bedrijf && username.bedrijf.modules.includes("items")) {
    if (token.role === "admin" || token.role === "manager" || token.role === "medewerker") {
      return (
        <div className="menu-item">
          <div className="menu-link" onClick={onToggle}>
            <span className="menu-icon"><i className="fa fa-window-restore"></i></span>
            <span className="menu-text">VVV Items</span>
            <span className={`menu-arrow ${isActive ? "rotate" : ""}`}><i className="fas fa-chevron-right"></i></span>
          </div>
          <div className={`menu-sub ${isActive ? "show" : ""}`}>
            <div className="menu-item">
              <Link to="/items" className="menu-link">
                <span className="menu-icon"><i className="fa fa-book"></i></span>
                <span className="menu-text">VVV Items</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/items/add" className="menu-link">
                <span className="menu-icon"><i className="fa fa-book"></i></span>
                <span className="menu-text">VVV Items Toevoegen</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/items/top" className="menu-link">
                <span className="menu-icon"><i className="fa fa-book"></i></span>
                <span className="menu-text">VVV Items TOP</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/items/tags" className="menu-link">
                <span className="menu-icon"><i className="fa fa-book"></i></span>
                <span className="menu-text">VVV Items Tags</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/items/arrangementen" className="menu-link">
                <span className="menu-icon"><i className="fa fa-book"></i></span>
                <span className="menu-text">Arrangementen</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/items/list/tags" className="menu-link">
                <span className="menu-icon"><i className="fa fa-book"></i></span>
                <span className="menu-text">Lijst Tags</span>
              </Link>
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  } else {
    return null;
  }
};
export default ItemsMenu;
